import React from 'react';
import { useQueryString } from 'helpers/effects';
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
import PaymentList from 'components/Payment/List';

const ScreenPaymentList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <PaymentList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenPaymentList;
